import { motion } from "framer-motion";

const word = {
  hidden: { opacity: 0, y: "0.6em", filter: "blur(6px)" },
  show: { opacity: 1, y: 0, filter: "blur(0px)", transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
};

const Words = ({ text, className = "" }) =>
  text.split(" ").map((w, i) => (
    <motion.span key={`${w}-${i}`} variants={word} className={`inline-block pr-[0.25em] ${className}`}>{w}</motion.span>
  ));

export const AnimatedHeadline = ({
  line1,
  line2,
  size = "text-5xl sm:text-6xl lg:text-7xl",
  accent = "from-amber-600 via-orange-500 to-rose-600",
}) => (
  <motion.h1
    key={`${line1}${line2}`}
    initial="hidden"
    animate="show"
    transition={{ staggerChildren: 0.12, delayChildren: 0.15 }}
    className={`mt-6 font-heading font-extrabold leading-[1.05] tracking-tight text-slate-900 ${size}`}
    data-testid="hero-title"
  >
    <Words text={line1} />
    <br />
    <Words text={line2} className={`bg-gradient-to-r ${accent} bg-clip-text text-transparent`} />
  </motion.h1>
);
